export const invoices = [
    {
        billTo: 'Abdul jabbar',
        billName: 'January to March Tuition fee',
        date: '15/01/2021',
        totalBill: 15000,
        paidBill: 10000,
        deuBill: 5000,
        invoiceId: 'INV 001451',
        receptNo: '645',
        status: 'pending'
    },
    {
        billTo: 'Abdul jabbar',
        billName: 'Semester 2nd Installment',
        date: '03/01/2021', totalBill: 5000,
        paidBill: 5000,
        deuBill: '',
        invoiceId: 'INV 00121',
        receptNo: '234',
        status: 'Paid'
    },
    {
        billTo: 'Abdul jabbar',
        billName: 'Semester 1st Installment',
        date: '01/01/2021',
        totalBill: 4500,
        paidBill: 4500,
        deuBill: '',
        invoiceId: 'INV 00120',
        receptNo: '127',
        status: 'Paid'
    },
    {
        billTo: 'Abdul jabbar',
        billName: 'December  Tuition fee',
        date: '21/12/2020',
        totalBill: '1500',
        paidBill: 1500,
        deuBill: '',
        invoiceId: 'INV 00141',
        receptNo: '455',
        status: 'Paid'
    }
]   